import { useAsync } from '@/hooks/useAsync';
import { buscaDesempenho, buscaDesempenhoAdmin } from './service';
import type { Desempenho } from './types';

// Cache simples em memória: o painel e a página da disciplina usam os mesmos dados.
const cache = new Map<string, Promise<Desempenho>>();

/**
 * Desempenho do aluno logado, ou de um RA qualquer quando é o professor olhando ("ver como aluno"),
 * no semestre pedido (sem semestre: o mais recente publicado).
 */
export function useDesempenho(ra?: string, semestre?: string) {
  const chave = `${ra ?? 'eu'}|${semestre ?? ''}`;
  return useAsync(() => {
    let p = cache.get(chave);
    if (!p) {
      // sem AbortSignal: a mesma promessa é compartilhada entre telas (e entre as montagens do StrictMode)
      p = ra ? buscaDesempenhoAdmin(ra, semestre) : buscaDesempenho(semestre);
      cache.set(chave, p);
      p.catch(() => cache.delete(chave));
    }
    return p;
  }, [chave]);
}

export const limpaCacheDesempenho = () => cache.clear();
